import React, { type FC, useEffect } from 'react';

import Toast from '../../common/components/Toast';
import { useUiState, useHandlers } from '../widgets';

const toastFadeOutDelay = 5000;

// TODO: Wrap Toast with Loadable afterwards. https://jira.wixpress.com/browse/MA-2915
export const ToastContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { toast } = useUiState();
  const { hideToast } = useHandlers();

  useEffect(() => {
    if (toast.isVisible) {
      const timeout = setTimeout(hideToast, toastFadeOutDelay);
      return () => clearTimeout(timeout);
    }
  }, [toast.isVisible, hideToast]);

  return (
    <>
      <Toast />
      {children}
    </>
  );
};
